import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { PreAuthPermissionGate } from '../../../components/PreAuthPermissionGate';
import { AllowedProvider, allowedConnectOptionsSchema } from '../../../constants/common';

const searchParamsSchema = z.object({
  port: z.coerce.number(),
  authUrl: z.string(),
});

export const Route = createFileRoute('/auth/connect/$provider/pre-auth')({
  validateSearch: searchParamsSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ params: { provider }, deps: { port, authUrl } }) => {
    // Validate provider
    const providerResult = allowedConnectOptionsSchema.safeParse(provider);
    if (!providerResult.success) {
      throw redirect({ to: '/auth/$provider/error', params: { provider } });
    }

    // Validate that both params are provided
    if (!port || !authUrl) {
      throw redirect({ to: '/auth/$provider/error', params: { provider } });
    }

    return { port, authUrl, provider: providerResult.data };
  },
  component: ConnectPreAuth,
});

function ConnectPreAuth() {
  const { port, authUrl, provider } = Route.useLoaderData();

  return <PreAuthPermissionGate port={port} authUrl={authUrl} provider={provider as AllowedProvider} />;
}
